import * as React from 'react';
import { SVGProps } from 'react';

const IconVolumeUpSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.334 2.262a1 1 0 0 1 1.412.063c1.45 1.587 2.256 3.591 2.254 5.677-.002 2.086-.811 4.09-2.263 5.674a1 1 0 0 1-1.474-1.352C13.395 11.09 13.999 9.56 14 8c.001-1.56-.6-3.089-1.73-4.325a1 1 0 0 1 .064-1.413Z" />
    <path d="M9.398 4.204a1 1 0 0 1 1.402.19A5.956 5.956 0 0 1 12 8.001c0 1.307-.422 2.58-1.205 3.606a1 1 0 0 1-1.59-1.214C9.715 9.726 10 8.881 10 8c0-.88-.283-1.727-.792-2.394a1 1 0 0 1 .19-1.402ZM3.5 5l2.172-1.79C6.162 2.76 7 3.08 7 3.717v8.569c0 .636-.838.954-1.328.504L3.5 11H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.5Z" />
  </svg>
);
export default IconVolumeUpSizeS;
